import { makeStyles } from "@fluentui/react-components";
import { Column } from "./Column";


const useStyles = makeStyles({
    root: {
        position: 'fixed',
        right: '1.25rem',
        bottom: '1.25rem',
        zIndex: 1200,
    },
});

type FloatingTrayProps = {
    children?: React.ReactNode;
}
export const FloatingTray = (props: FloatingTrayProps) => {
    const { children } = props;
    
    //Styles
    const styles = useStyles();

    return (
        <Column className={styles.root} height='auto' maxHeight="70vh" >
            {children}
        </Column>
    );
};